import React, { FC, memo } from 'react'

import { TNeedHelpBottomSheet } from 'contexts/app-context/types/app-context/components/need-help'
import { Button } from 'common/styles/layouts'

import { Text } from '@interco/inter-ui/components/Text'
import { interWbNavigate } from '@interco/inter-webview-bridge'

import {
  BottomSheetContainer,
  ButtonContainer,
  ContentContainer,
} from '../styles/HelpCenterBottomSheet.styles'

export const HelpCenterBottomSheetView: FC<{
  content: TNeedHelpBottomSheet
  navigateTo: (route: string) => void
  onClose: () => void
}> = memo(({ content, navigateTo, onClose }) => {
  const { title, subTitle, firstButton, secondButton } = content
  return (
    <BottomSheetContainer>
      <ContentContainer>
        <Text variant="headline-h3" bold="true" colorWeight={500}>
          {title}
        </Text>
        <Text variant="body-3" colorWeight={400}>
          {subTitle}
        </Text>
      </ContentContainer>
      {firstButton?.isActive && (
        <ButtonContainer>
          <Button
            disabled={firstButton?.isDisabled}
            variant={firstButton?.variant}
            onClick={() => {
              if (firstButton?.to) interWbNavigate.openDeepLink(firstButton.to || '')
              else onClose()
            }}
          >
            {firstButton?.title}
          </Button>
        </ButtonContainer>
      )}
      {secondButton?.isActive && (
        <ButtonContainer>
          <Button
            disabled={secondButton?.isDisabled}
            variant={secondButton?.variant}
            onClick={() => {
              if (secondButton?.to) navigateTo(secondButton?.to)
              else onClose()
            }}
          >
            {secondButton?.title}
          </Button>
        </ButtonContainer>
      )}
    </BottomSheetContainer>
  )
})
